module.exports = __webpack_public_path__ + "img/step2chahua.c7606f79.png";